import { Container } from '@mui/material';
import getPageMetaTags from '../../../lib/meta/_getMetaTags';
import FundList from '../../../src/components/Browse/FundList';
import { getFundsJSONData } from '../../../src/utils/helpers';

export default function BrowseStocks({ themeMode, funds_data, sortedSections }) {
  return (
    <Container maxWidth="xl">
      <FundList fundData={funds_data} sortedSections={sortedSections} />
    </Container>
  );
}

export async function getServerSideProps({ params }) {
  const baseUrl = process.env.NODE_ENV === 'development'
    ? 'http://localhost:3000'
    : process.env.NEXT_PUBLIC_URL;

  try {
    const filtered_funds_data = await getFundsJSONData({
      url: `${baseUrl}/api/get-fund-data`,
      alphabet: params?.alphabet,
    }) || [];

    let groupedAndSorted = filtered_funds_data.reduce((acc, item) => {
      let key;
      if (item && item.n) {
        const firstChar = item.n.charAt(0).toUpperCase();
        key = isNaN(firstChar) ? firstChar : '#';
      } else {
        key = '#';
      }
      acc[key] = acc[key] || [];
      acc[key].push(item);
      return acc;
    }, {});

    for (const key in groupedAndSorted) {
      if (groupedAndSorted.hasOwnProperty(key)) {
        groupedAndSorted[key].sort((a, b) => a.n.localeCompare(b.n));
      }
    }

    const sortedSections = Object.keys(groupedAndSorted).sort((a, b) => {
      if (a === '#') return -1;
      if (b === '#') return 1;
      return a.localeCompare(b);
    });

    const meta_tags = (await getPageMetaTags('/blogs', false)) || {};
    const { getMetaTags } = meta_tags || {};

    return {
      props: {
        meta_tags: getMetaTags?.tags || null,
        funds_data: groupedAndSorted,
        sortedSections,
      },
    };
  } catch (error) {
    console.error('Error fetching fund data:', error);
    return {
      notFound: true,
    };
  }
}

// import { Container, } from '@mui/material';
// import { dataConstants } from '../../../src/constants';
// import getPageMetaTags from '../../../lib/meta/_getMetaTags';
// import FundList from '../../../src/components/Browse/FundList';
// import { getFundsJSONData } from '../../../src/utils/helpers';

// export default function BrowseStocks({ themeMode, funds_data, sortedSections }) {
//   return (
//     <>
//       <Container maxWidth="xl">
//         <FundList fundData={funds_data} sortedSections={sortedSections} />
//       </Container>
//     </>
//   )
// }

// export async function getStaticPaths() {
//   const alphabets = Array.from({ length: 26 }, (_, index) => String.fromCharCode(65 + index));
//   const paths = alphabets.map(a => ({ params: { alphabet: a.toLowerCase() } }))

//   return {
//     paths,
//     fallback: 'blocking'
//   }
// }

// export async function getStaticProps({ params, type = "stock", limit = 15 }) {
//   const baseUrl = process.env.NODE_ENV === 'development'
//     ? 'http://localhost:3000'
//     : process.env.NEXT_PUBLIC_URL;
//   let groupedAndSorted;
//   // const funds_data = require('../../../public/assets/search/funds.json');
//   // const filtered_funds_data = funds_data.filter((fund) => fund.n.toLowerCase().startsWith(params?.alphabet.toLowerCase()));
//   const filtered_funds_data = await getFundsJSONData({
//     url: `${baseUrl}/api/get-fund-data`,
//     alphabet: params?.alphabet,
//   }) || [];

//   try {
//     groupedAndSorted = filtered_funds_data?.reduce((acc, item) => {
//       let key;

//       if (item && item.n) {
//         const firstChar = item.n.charAt(0).toUpperCase();
//         key = isNaN(firstChar) ? firstChar : '#'; // Check if it's a number
//       } else {
//         key = '#'; // Default to '#' if n is undefined or null
//       }

//       acc[key] = acc[key] || [];
//       acc[key].push(item);
//       return acc;
//     }, {});

//     for (const key in groupedAndSorted) {
//       if (groupedAndSorted.hasOwnProperty(key)) {
//         if (key === '#') {
//           groupedAndSorted[key].sort((a, b) => a.n.localeCompare(b.n));
//         } else {
//           groupedAndSorted[key].sort((a, b) => a.n.localeCompare(b.n));
//         }
//       }
//     }
//   } catch (error) {
//     console.error('Error during grouping and sorting:', error);
//   }

//   if (!groupedAndSorted) {
//     console.error('Grouped and sorted data is undefined.');
//   }

//   const sortedSections = Object.keys(groupedAndSorted).sort((a, b) => {
//     if (a === '#') return -1; // '#' section should come first
//     if (b === '#') return 1;
//     return a.localeCompare(b); // Sort other sections alphabetically
//   });

//   const meta_tags = (await getPageMetaTags('/blogs', false)) || {}
//   const { getMetaTags } = meta_tags || {}

//   return {
//     props: {
//       meta_tags: getMetaTags?.tags || null,
//       funds_data: groupedAndSorted,
//       sortedSections
//     },
//     revalidate: dataConstants.REVALIDATE_IN.SEVEN_DAYS,
//     // notFound: process.env.NODE_ENV !== 'production' ? false : true,
//   }
// }
